// removed by extract-text-webpack-plugin
module.exports = {"whiteColor":"#fff","developerPrimaryColor":"#589e69","professionalPrimaryColor":"#13B9E4","enterprisePrimaryColor":"#eca85a","premiumPrimaryColor":"#FFFFFF59","premiumGradientColor":"transparent linear-gradient(44deg, #5000B7 0%, #21024A 100%) 0% 0% no-repeat padding-box"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/variables.module.scss
// module id = 587
// module chunks = 226020273838829